import React from "react";
import { PILLARS } from "../mock";

const BENEFITS = [
  { title: "Personalized", body: "Your plan, your schedule, your budget. We adapt every pillar to fit your life." },
  { title: "Integrated", body: "Nutrition, training, recovery and bloodwork all coordinated by one team." },
  { title: "Evidence-Based", body: "Protocols informed by peer-reviewed longevity science." },
  { title: "Local & In-Person", body: "Sessions in Basel — gym, pool, spa, and Alpine outings." },
];

export default function WhyLongev() {
  return (
    <section className="relative bg-[var(--lc-cream-soft)] py-20 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="eyebrow text-[var(--lc-moss)] mb-5">Why LONGEV CIRCLE</div>
            <h2 className="font-serif-display text-[clamp(36px,5vw,68px)] leading-[1] font-light">
              The gym era is over.<br /><span className="italic">Longevity is the new fitness.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5 lg:gap-7">
            {BENEFITS.map((b, i) => (
              <div key={b.title} className="bg-white border border-[var(--lc-line)] rounded-md p-6 lg:p-7">
                <div className="font-serif-display text-base text-[var(--lc-moss)] mb-3">0{i + 1}</div>
                <h3 className="font-serif-display text-2xl leading-tight">{b.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[var(--lc-muted)]">{b.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
